import React from "react";

const LABELS = {
  reminder_sent: "Reminder sent",
  confirmation_sent: "Confirmation sent",
  invitation_sent: "Invitation sent",
  history_unknown: "Signed up · email history unknown",
  email_history_unknown: "Email history unknown",
  signed_up: "Signed up · confirmation not sent",
  not_sent: "No email recorded",
  unavailable: "Email status unavailable",
};

export default function SharingTreeOutreachBadge({ status }) {
  const stage = status?.stage || "unavailable";
  const accepted = stage.endsWith("_sent") && stage !== "not_sent";
  let label = LABELS[stage] || LABELS.unavailable;
  if (stage === "signed_up" && status.confirmation_status === "sending") {
    label = "Signed up · confirmation pending";
  }
  if (stage === "signed_up" && status.confirmation_status === "failed") {
    label = "Signed up · confirmation failed";
  }
  return (
    <div className="text-xs min-w-[145px]">
      <span className={`inline-block px-2 py-1 rounded-lg font-semibold ${accepted ? "fb-status-success" : ""}`}
        style={!accepted ? { background: "#F1F5F9", color: "#475569" } : undefined}
        title={accepted ? "Accepted by the email provider; delivery and opening are not confirmed." : undefined}>
        {label}
      </span>
      {accepted && status?.sent_at && <div className="mt-1" style={{ color: "var(--fb-text-muted)" }}>
        {new Date(status.sent_at).toLocaleString()}
      </div>}
    </div>
  );
}
